import { createStore } from 'vuex'
import SecurityStore from '@/user/store/security.store'
import AccountStore from '@/user/store/account/account.store'
import AttendStore from '@/user/store/attend/attend.store'
import AlertStore from '@/user/store/dialogs/alert.store'
import CertificationStore from '@/user/store/certification/certification.store'
import HomeStore from '@/user/store/home/home.store'
import GlobalStore from '@/user/store/global.store'
import LoaderStore from '@/user/store/loader/loader.store'
import ExamStore from '@/user/store/exam/exam.store'

export default createStore({
  modules: {
    SecurityStore,
    AccountStore,
    AttendStore,
    AlertStore,
    CertificationStore,
    HomeStore,
    GlobalStore,
    LoaderStore,
    ExamStore,
  },
})
